// extracted by mini-css-extract-plugin
module.exports = {"title":"DeliveryServices_title__w_GSD","services":"DeliveryServices_services__h6JCC"};